import React from "react";

// Matches travel-qr Checkbox exactly — sr-only input + custom styled div
export default function TravelCheckbox({ isChecked, onChange, id, isDisabled = false }) {
  return (
    <div style={{ position: "relative", display: "inline-block", lineHeight: 0 }}>
      <input
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={onChange}
        disabled={isDisabled}
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0,0,0,0)",
          border: 0,
        }}
      />
      <div
        onClick={isDisabled ? undefined : onChange}
        style={{
          width: 18,
          height: 18,
          border: `1px solid #079f9f`,
          borderRadius: 2,
          backgroundColor: isChecked ? "#079f9f" : "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: isDisabled ? "default" : "pointer",
          opacity: isDisabled ? 0.5 : 1,
          transition: "background-color 0.15s",
          boxSizing: "border-box",
          flexShrink: 0,
        }}
      >
        {isChecked && (
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
            <path
              d="M3 8L6.5 11L13 4"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
}
